import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { linkPortal } from '../lib/portal';

function fmtDataHora(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleString('pt-BR', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
}

export default function AreaCliente() {
  const navigate = useNavigate();
  const [linhas, setLinhas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [copiadoId, setCopiadoId] = useState(null);
  const [editandoLogoId, setEditandoLogoId] = useState(null);
  const [logoValor, setLogoValor] = useState('');
  const [editandoContatoId, setEditandoContatoId] = useState(null);
  const [contatoValor, setContatoValor] = useState({ contato_whatsapp_atendimento:'', contato_whatsapp:'', contato_email:'', oab:'', advogado_nome:'', advogado_bio:'' });

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    setCarregando(true);
    const [{ data: projetos }, { data: acessos }, { data: casos }] = await Promise.all([
      supabase.from('projetos').select('id, nome, cor, portal_token, logo_url, contato_whatsapp, contato_whatsapp_atendimento, contato_email, oab, advogado_nome, advogado_bio').order('nome'),
      supabase.from('portal_acessos').select('projeto_id, acessado_em').order('acessado_em', { ascending:false }),
      supabase.from('casos').select('projeto_id, nome_cliente'),
    ]);
    const linhasCalc = (projetos||[]).map(p => {
      const doProjeto = (acessos||[]).filter(a => a.projeto_id === p.id);
      const clientesDoProjeto = new Set((casos||[]).filter(c => c.projeto_id === p.id).map(c => c.nome_cliente));
      return { ...p, totalAcessos: doProjeto.length, ultimoAcesso: doProjeto[0]?.acessado_em || null, totalClientes: clientesDoProjeto.size };
    });
    setLinhas(linhasCalc);
    setCarregando(false);
  }

  async function copiar(p) {
    if (!p.portal_token) return;
    await navigator.clipboard.writeText(linkPortal(p.portal_token));
    setCopiadoId(p.id);
    setTimeout(() => setCopiadoId(null), 1500);
  }

  function abrirEdicaoLogo(p) {
    setEditandoLogoId(p.id);
    setLogoValor(p.logo_url || '');
  }

  async function salvarLogo(p) {
    const valor = logoValor.trim() || null;
    const { data } = await supabase.from('projetos').update({ logo_url: valor }).eq('id', p.id).select('id, logo_url').single();
    if (data) setLinhas(linhas.map(l => l.id === p.id ? { ...l, logo_url: data.logo_url } : l));
    setEditandoLogoId(null);
  }

  function abrirEdicaoContato(p) {
    setEditandoContatoId(p.id);
    setContatoValor({
      contato_whatsapp_atendimento: p.contato_whatsapp_atendimento || '',
      contato_whatsapp: p.contato_whatsapp || '',
      contato_email: p.contato_email || '',
      oab: p.oab || '',
      advogado_nome: p.advogado_nome || '',
      advogado_bio: p.advogado_bio || '',
    });
  }

  async function salvarContato(p) {
    const payload = {
      contato_whatsapp_atendimento: contatoValor.contato_whatsapp_atendimento.trim() || null,
      contato_whatsapp: contatoValor.contato_whatsapp.trim() || null,
      contato_email: contatoValor.contato_email.trim() || null,
      oab: contatoValor.oab.trim() || null,
      advogado_nome: contatoValor.advogado_nome.trim() || null,
      advogado_bio: contatoValor.advogado_bio.trim() || null,
    };
    const { data } = await supabase.from('projetos').update(payload).eq('id', p.id)
      .select('id, contato_whatsapp_atendimento, contato_whatsapp, contato_email, oab, advogado_nome, advogado_bio').single();
    if (data) setLinhas(linhas.map(l => l.id === p.id ? { ...l, ...data } : l));
    setEditandoContatoId(null);
  }

  if (carregando) return <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>Carregando...</div>;

  return (
    <div>
      <div className="section-header"><h2 className="section-title">Área do Cliente</h2><div className="section-line" /></div>
      <p style={{ fontSize:12.5, color:'var(--text-secondary)', marginBottom:20 }}>
        Todos os links de portal por projeto, quantos acessos cada um já teve e a última vez que o cliente entrou.
        O link do caso individual (o que vai pro cliente final acompanhar só o processo dele) fica dentro de cada caso, na aba Casos.
      </p>

      <div className="card" style={{ overflow:'hidden' }}>
        {linhas.map((p, i) => (
          <div key={p.id} style={{ borderBottom: i<linhas.length-1?'1px solid rgba(107,33,168,0.06)':'none' }}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr auto auto auto auto auto auto auto', gap:14, alignItems:'center', padding:'14px 18px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:10 }}>
              <div style={{ width:8, height:8, borderRadius:'50%', background:p.cor||'var(--purple)' }} />
              <span style={{ fontWeight:600, fontSize:13, color:'var(--text-primary)' }}>{p.nome}</span>
            </div>
            <div style={{ fontSize:11.5, color:'var(--text-secondary)', textAlign:'right', whiteSpace:'nowrap' }}>
              👥 {p.totalClientes} cliente{p.totalClientes!==1?'s':''}
            </div>
            <div style={{ fontSize:12, color:'var(--text-secondary)', textAlign:'right' }}>
              {p.totalAcessos} acesso{p.totalAcessos!==1?'s':''}
            </div>
            <div style={{ fontSize:11.5, color:'var(--gray-400)', textAlign:'right', whiteSpace:'nowrap' }}>
              {p.ultimoAcesso ? `último: ${fmtDataHora(p.ultimoAcesso)}` : 'nunca acessado'}
            </div>
            <button onClick={() => navigate(`/roteiros-cliente/${p.id}`)}
              style={{ background:'transparent', border:'1px solid var(--border)', color:'var(--text-secondary)', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:11.5, whiteSpace:'nowrap' }}>
              🎬 Roteiros
            </button>
            <button onClick={() => navigate(`/relatorio-cliente/${p.id}`)}
              style={{ background:'transparent', border:'1px solid var(--border)', color:'var(--text-secondary)', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:11.5, whiteSpace:'nowrap' }}>
              📊 Relatório
            </button>
            <button onClick={() => navigate(`/playbook-cliente/${p.id}`)}
              style={{ background:'transparent', border:'1px solid var(--border)', color:'var(--text-secondary)', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:11.5, whiteSpace:'nowrap' }}>
              📋 Playbook
            </button>
            <button onClick={() => copiar(p)} disabled={!p.portal_token}
              style={{ background:'var(--purple)', color:'white', border:'none', padding:'6px 14px', borderRadius:6, cursor:'pointer', fontSize:11.5, fontWeight:700, whiteSpace:'nowrap' }}>
              {copiadoId===p.id ? '✓ copiado' : '🔗 Copiar link'}
            </button>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10, padding:'0 18px 12px 18px' }}>
            {p.logo_url && <img src={p.logo_url} alt="" style={{ width:22, height:22, borderRadius:5, objectFit:'cover' }} />}
            {editandoLogoId === p.id ? (
              <>
                <input autoFocus value={logoValor} onChange={e => setLogoValor(e.target.value)}
                  onKeyDown={e => e.key==='Enter' && salvarLogo(p)}
                  placeholder="URL da logo (aparece no link do caso do cliente final)"
                  style={{ flex:1, maxWidth:420, padding:'5px 9px', border:'1px solid var(--border)', borderRadius:6, fontSize:11.5 }} />
                <button onClick={() => salvarLogo(p)} style={{ background:'var(--purple)', color:'white', border:'none', padding:'5px 12px', borderRadius:6, cursor:'pointer', fontSize:11, fontWeight:700 }}>Salvar</button>
                <button onClick={() => setEditandoLogoId(null)} style={{ background:'transparent', border:'none', color:'var(--text-secondary)', cursor:'pointer', fontSize:11 }}>cancelar</button>
              </>
            ) : (
              <button onClick={() => abrirEdicaoLogo(p)} style={{ background:'transparent', border:'none', color:'var(--text-secondary)', cursor:'pointer', fontSize:11, textDecoration:'underline', padding:0 }}>
                🎨 {p.logo_url ? 'trocar logo do cliente final' : 'definir logo do cliente final'}
              </button>
            )}
          </div>
          <div style={{ padding:'0 18px 14px 18px' }}>
            {editandoContatoId === p.id ? (
              <div style={{ display:'flex', flexDirection:'column', gap:8, background:'#FAF8FF', border:'1px solid rgba(107,33,168,0.1)', borderRadius:10, padding:12 }}>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  <input autoFocus value={contatoValor.contato_whatsapp_atendimento} onChange={e => setContatoValor({...contatoValor, contato_whatsapp_atendimento:e.target.value})}
                    placeholder="WhatsApp de atendimento (por onde o cliente chegou)"
                    style={{ flex:1, minWidth:220, padding:'6px 9px', border:'1px solid var(--border)', borderRadius:6, fontSize:11.5 }} />
                  <input value={contatoValor.contato_whatsapp} onChange={e => setContatoValor({...contatoValor, contato_whatsapp:e.target.value})}
                    placeholder="WhatsApp de pós-venda"
                    style={{ flex:1, minWidth:220, padding:'6px 9px', border:'1px solid var(--border)', borderRadius:6, fontSize:11.5 }} />
                </div>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  <input value={contatoValor.contato_email} onChange={e => setContatoValor({...contatoValor, contato_email:e.target.value})}
                    placeholder="E-mail de contato"
                    style={{ flex:1, minWidth:220, padding:'6px 9px', border:'1px solid var(--border)', borderRadius:6, fontSize:11.5 }} />
                  <input value={contatoValor.oab} onChange={e => setContatoValor({...contatoValor, oab:e.target.value})}
                    placeholder="OAB (ex: OAB/DF 77.646)"
                    style={{ width:180, padding:'6px 9px', border:'1px solid var(--border)', borderRadius:6, fontSize:11.5 }} />
                </div>
                <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                  <input value={contatoValor.advogado_nome} onChange={e => setContatoValor({...contatoValor, advogado_nome:e.target.value})}
                    placeholder="Advogado(a) titular (ex: Dr. Gabriel Melo Xavier)"
                    style={{ flex:1, minWidth:220, padding:'6px 9px', border:'1px solid var(--border)', borderRadius:6, fontSize:11.5 }} />
                </div>
                <textarea value={contatoValor.advogado_bio} onChange={e => setContatoValor({...contatoValor, advogado_bio:e.target.value})}
                  placeholder="Bio curta do advogado(a), aparece no manual do cliente" rows={2}
                  style={{ padding:'6px 9px', border:'1px solid var(--border)', borderRadius:6, fontSize:11.5, resize:'vertical' }} />
                <div>
                  <button onClick={() => salvarContato(p)} style={{ background:'var(--purple)', color:'white', border:'none', padding:'6px 14px', borderRadius:6, cursor:'pointer', fontSize:11.5, fontWeight:700, marginRight:8 }}>Salvar</button>
                  <button onClick={() => setEditandoContatoId(null)} style={{ background:'transparent', border:'none', color:'var(--text-secondary)', cursor:'pointer', fontSize:11.5 }}>cancelar</button>
                </div>
              </div>
            ) : (
              <button onClick={() => abrirEdicaoContato(p)} style={{ background:'transparent', border:'none', color:'var(--text-secondary)', cursor:'pointer', fontSize:11, textDecoration:'underline', padding:0 }}>
                📞 {(p.contato_whatsapp || p.contato_whatsapp_atendimento || p.oab || p.advogado_nome) ? `${p.advogado_nome || p.contato_whatsapp_atendimento || ''}${p.oab ? ' · ' + p.oab : ''} — editar contato do manual` : 'definir contato/advogado titular pro manual do cliente final'}
              </button>
            )}
          </div>
          </div>
        ))}
        {linhas.length===0 && <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>Nenhum projeto cadastrado ainda.</div>}
      </div>
    </div>
  );
}
